import { BoxStylingOutlineIcon } from '@carboncopyco/icons';
import type { IDynamicEditData } from '@carboncopyco/types';
import { ModificationItem } from './ModificationItem';

export const StyleModificationItem = ({
  edit,
}: {
  edit: IDynamicEditData['element'];
}) => {
  return (
    <ModificationItem>
      <ModificationItem.Content>
        <ModificationItem.Icon>
          <BoxStylingOutlineIcon size={18} />
        </ModificationItem.Icon>
        <ModificationItem.Text
          label={edit.new.value || 'Unknown css property'}
        />
      </ModificationItem.Content>
    </ModificationItem>
  );
};
